/** Mapping between the «part of day» picker and the server's `timePrecision` (shared by onboarding and «Мои карты»). */
import type { TimeOfDay } from '../components/onboarding/TimeOfDayPicker';
import type { TimePrecision } from '../hooks/usePatchBirthData';

export const TIME_OF_DAY_TO_PRECISION: Record<TimeOfDay, Exclude<TimePrecision, 'EXACT'>> = {
  morning: 'MORNING',
  day: 'AFTERNOON',
  evening: 'EVENING',
  night: 'NIGHT',
};

export const PRECISION_TO_TIME_OF_DAY: Record<Exclude<TimePrecision, 'EXACT'>, TimeOfDay> = {
  MORNING: 'morning',
  AFTERNOON: 'day',
  EVENING: 'evening',
  NIGHT: 'night',
};

/** `HH:MM` → part of day; null when the string is not `HH:MM`. */
export function deriveTimeOfDayFromExact(hhmm: string): TimeOfDay | null {
  const m = /^(\d{2}):(\d{2})$/.exec(hhmm);
  if (!m) return null;
  const h = parseInt(m[1], 10);
  if (h >= 6 && h < 12) return 'morning';
  if (h >= 12 && h < 18) return 'day';
  if (h >= 18 && h < 23) return 'evening';
  return 'night';
}
